interface JsonLdProps {
  schema: Record<string, unknown> | Record<string, unknown>[];
}

/**
 * Renders JSON-LD only during static rendering. The pre-renderer moves it to
 * the document head; the hydrated client does not duplicate the schema.
 */
export function JsonLd({ schema }: JsonLdProps) {
  if (typeof window !== "undefined") return null;

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}
